import { Chain, ChainType } from '@ankr.com/chains-list';

import { isTestnetOnlyChain } from 'modules/chains/utils/isTestnetOnlyChain';

interface CheckSubnetsArguments {
  chain: Chain;
  nets: Chain[];
  subnetTab: ChainType;
  netId?: string;
  isMainnetPremiumOnly?: boolean;
  isTestnetPremiumOnly?: boolean;
}

const checkSubnets = ({
  chain,
  isMainnetPremiumOnly,
  isTestnetPremiumOnly,
  netId,
  nets,
  subnetTab,
}: CheckSubnetsArguments) => {
  const isTestnetOnly =
    !chain.paths?.length &&
    !chain.extensions?.length &&
    !chain.devnets?.length &&
    !chain.signets?.length &&
    !chain.beacons?.length &&
    !chain.opnodes?.length &&
    !chain.extenders?.length &&
    !!chain.testnets?.length;

  const isSubnetTab = nets?.find(
    el =>
      netId?.includes(el.id) || el.extensions?.some(({ id }) => netId === id),
  );

  const isMainnetDisabledAndNets = isMainnetPremiumOnly && nets?.length > 0;

  if (isMainnetPremiumOnly && isTestnetPremiumOnly) return undefined;

  return isSubnetTab || isMainnetDisabledAndNets || isTestnetOnly
    ? subnetTab
    : undefined;
};

interface GetInitialChainTypeParams {
  chain: Chain;
  netId?: string;
  isMainnetPremiumOnly?: boolean;
  isTestnetPremiumOnly?: boolean;
  isHiddenMainnet?: boolean;
  selectedType?: ChainType;
}

export const getInitialChainType = ({
  chain,
  isHiddenMainnet,
  isMainnetPremiumOnly,
  isTestnetPremiumOnly,
  netId,
  selectedType,
}: GetInitialChainTypeParams): ChainType => {
  if (selectedType) {
    return selectedType;
  }

  const { devnets = [], id, testnets = [] } = chain;

  if (isTestnetOnlyChain(id) || isHiddenMainnet) {
    return ChainType.Testnet;
  }

  const testnetTab = checkSubnets({
    chain,
    nets: testnets,
    subnetTab: ChainType.Testnet,
    netId,
    isMainnetPremiumOnly,
    isTestnetPremiumOnly,
  });

  const devnetTab = checkSubnets({
    chain,
    nets: devnets,
    subnetTab: ChainType.Devnet,
    netId,
    isMainnetPremiumOnly,
    isTestnetPremiumOnly,
  });

  return testnetTab || devnetTab || ChainType.Mainnet;
};
